<template>
  <div class="spinner" v-if="loaderStatus">
    <v-spin :spinning="loaderStatus">
    </v-spin>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'loaderStatus'
    ])
  }
}
</script>

<style scoped>
  .spinner {
    display: flex;
    width: 100%;
    height: 100vh;
    background-color: rgba(0,0,0,0.25);
    z-index: 22;
    position: fixed;
    left: 0;
    top: 0;
    align-items: center;
    justify-content: center;
  }
  .spinner .ant-spin {
    z-index: 23;
  }
  .ant-spin-dot i {
    background-color: #e9102c !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue